"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Question = exports.Content = exports.Answer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setFontStyle = (style, bold, question) => {
  switch (style) {
    case 'normal':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        headline: bold,
        display: bold
      })}
        ${(0, _typography.setFontSizes)({
        xs: question ? '24px' : '16px',
        xl: question ? '32px' : '19px'
      })}
        letter-spacing: -0.03em;
        line-height: ${question ? '110%' : '140%'};
        font-weight: ${bold ? 900 : 0};
      `;
    case 'deville':
      return (0, _styledComponents.css)`
        ${(0, _typography.setFont)({
        display: true
      })}
        ${(0, _typography.setFontSizes)({
        xs: question ? '24px' : '16px',
        xl: question ? '32px' : '19px'
      })}
        letter-spacing: 0.012em;
        line-height: ${question ? '110%' : '140%'};
        font-weight: ${bold ? 900 : 0};
      `;
    case 'roboto':
      return (0, _styledComponents.css)`
        font-family: 'robotomono-regular', sans-serif;
        ${(0, _typography.setFontSizes)({
        xs: '12px',
        xl: '12px'
      })}
        line-height: 18px;
        text-transform: uppercase;
        font-weight: ${bold ? 900 : 0};
      `;
    case 'helvetica':
      return (0, _styledComponents.css)`
        font-family: 'helvetica-neue', sans-serif;
        ${(0, _typography.setFontSizes)({
        xs: '26px',
        xl: '28px'
      })}
        line-height: 32px;
        font-weight: ${bold ? 900 : 0};
      `;
    default:
      return (0, _styledComponents.css)`
        font-family: 'univers-black', sans-serif;
        ${(0, _typography.setFontSizes)({
        xs: question ? '24px' : '16px',
        xl: question ? '32px' : '19px'
      })}
        line-height: ${question ? '110%' : '140%'};
      `;
  }
};
const Content = _styledComponents.default.div`
  ${(0, _layout.setContainer)({
  size: 'lg'
})};
  ${props => props.positioning && `
     & > div {
      padding-bottom: 20px;
    }
   `};
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    display: ${props => props.positioning ? 'grid' : 'block'};
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
  }
  @media (min-width: ${_breakpoints.BREAKPOINTS.xs}px) {
    & > div {
      padding-bottom: 20px;
    }
  }
`;
exports.Content = Content;
const Question = _styledComponents.default.div`
  ${props => setFontStyle(props.questionFontStyle, props.bold, true)};
  color: ${props => props.color || 'black'};
  margin: 0;
  &.animation-transform,
  & > div {
    will-change: transform;
  }
`;
exports.Question = Question;
const Answer = _styledComponents.default.div`
  ${props => setFontStyle(props.answerFontStyle, props.bold, false)};
  color: ${props => props.color || 'black'};
  margin: 0;
`;
exports.Answer = Answer;
//# sourceMappingURL=styles.js.map